export enum InsurerName {
  Balcia = "Balcia",
  BTA = "BTA",
  Compensa = "Compensa",
  Ergo = "Ergo",
  Gjensidige = "Gjensidige",
  IF = "IF",
  LietuvosDraudimas = "LietuvosDraudimas",
}

export enum AdditionalInsurances {
  IncludeExtendedRoadAssistance = "IncludeExtendedRoadAssistance",
  IncludeDriverAccidentInsurance = "IncludeDriverAccidentInsurance",
  IncludeDriverAndPassingerAccidentInsurance = "IncludeDriverAndPassingerAccidentInsurance",
}

export const allInsurers: string[] = [
  InsurerName.Balcia,
  InsurerName.BTA,
  InsurerName.Compensa,
  InsurerName.Ergo,
  InsurerName.Gjensidige,
  InsurerName.IF,
  InsurerName.LietuvosDraudimas,
];

export interface SearchVehicleForm {
  VehicleLicensePlate: string;
  OwnerId: string;
}

// Sagauta MTPL

export interface AdditionalCalculationInfoDto {
  VehicleClass: number | null;
  VehicleUsage: number | null;
  OwnerDrivingLicenseDate: string | null;
  OwnerCity: number | null;
  OwnerEmail: string;
  OwnerTelephone: string;
  OtherDrivers: boolean | null;
  OtherDriverAge: number | null;
  OtherDriverExperience: number | null;
  PolicyStartDate: string | null;
  PolicyPeriod: number | null;
  PaymentCount: number | null;
}

export interface Balcia extends BaseForInsurerSpecificInfoDto {}

export interface BaseForCalculationAndOfferDto {
  Request: CalculationOrOfferRequestDto;
  Response: CalculationOrOfferResponseDto;
  IsOwnerLegalPerson: boolean | null;
  IsInvalidated: boolean | null;
  IsArchived: boolean | null;
  SecurityInformation: string[];
  _etag: string;
}

export interface CalculationDto extends BaseForCalculationAndOfferDto {
  CalculationId: string;
  CalculationRequestedAt: string | null;
  CalculationRequestedBy: string;
  CalculationRequestedByUsername: string;
  CalculationRequestedByUserFullName: string;
}

export interface OfferListEntryDto extends BaseForCalculationAndOfferDto {
  OfferId: string;
  OfferRequestedAt: string | null;
  OfferRequestedBy: string;
  OfferRequestedByUsername: string;
  OfferRequestedByUserFullName: string;
  SelectedInsurer: string;
  InvoiceId: string;
  InvoicePremium: number | null;
  InvoiceIssuedAt: string | null;
  InvoiceIssuedBy: string;
  InvoiceIssuedByUsername: string;
  InvoiceIssuedByUserFullName: string;
  InvoicePaymentDate: string;
  PolicyHolderAddressInfo: PolicyHolderAddressInfoDto;
  PolicyStatusMessage: string;
  PolicyId: string;
  PolicyNumber: string;
  PolicyHolderId: string;
  PolicyPremium: number | null;
  PolicyIssuedAt: string | null;
  PolicyIssuedBy: string;
  PolicyIssuedByUsername: string;
  PolicyIssuedByUserFullName: string;
  PolicyDocuments: PolicyDocumentWithPathDto[];
  LastModifiedAt: string | null;
  LastModifiedBy: string;
  LastModifiedByUsername: string;
  LastModifiedByUserFullName: string;
  Status: number | null;
  StatusDescription: string;
  PathToOfferPdf: string;
  PathToInvoicePdf: string;
  PolicyDocumentsStatusMessage: string;
  PathToPolicyIssuingResponseFromInsurer: string;
}

export interface PolicyDocumentWithPathDto extends PolicyDocumentBaseDto {
  Path: string | null;
}

export interface PolicyDocumentBaseDto {
  Name: string | null;
  Label: string | null;
  Type: string | null;
}

export interface PolicyHolderAddressInfoDto {
  SelectedInsurer: string;
  PolicyHolderEmail: string | null;
  PolicyHolderTelephone: string | null;
  PolicyHolderAdministrativeUnit: number | null;
  PolicyHolderLocality: number | null;
  PolicyHolderLocalityName: string | null;
  PolicyHolderStreet: number | null;
  PolicyHolderStreetName: string | null;
  PolicyHolderStreetNo: string | null;
  PolicyHolderFlatNo: string | null;
}

export interface BaseForInsurerSpecificInfoDto {
  IncludeExtendedRoadAssistance: boolean | null;
  IncludeDriverAccidentInsurance: boolean | null;
  IncludeDriverAndPassingerAccidentInsurance: boolean | null;
}

export interface BTA extends BaseForInsurerSpecificInfoDto {}

export interface CalculationOrOfferRequestDto {
  CorrelationId: string;
  VehicleInfo: VehicleInfoDto;
  AdditionalCalculationInfo: AdditionalCalculationInfoDto;
  InsurerSpecificInfos: InsurerSpecificInfosDto;
}

export interface CalculationOrOfferResponseDto {
  Balcia: MtplRateBaseDto;
  BTA: MtplRateBaseDto;
  Compensa: MtplRateBaseDto;
  Ergo: MtplRateBaseDto;
  Gjensidige: MtplRateBaseDto;
  IF: MtplRateBaseDto;
  LietuvosDraudimas: MtplRateBaseDto;
}

export interface Compensa extends BaseForInsurerSpecificInfoDto {
  PolicyCoverageEURAndGreenCardCountries: boolean | null;
  MiniCASCO: number | null;
}

export interface Ergo extends BaseForInsurerSpecificInfoDto {
  CompanyType: number | null;
  DiscountPercent: number | null;
}

export interface Gjensidige extends BaseForInsurerSpecificInfoDto {
  ApplyMaxDiscount: boolean | null;
  DiscountPercent: number | null;
  SpecialUsage: boolean | null;
}

export interface IF extends BaseForInsurerSpecificInfoDto {}

export interface InsurerSpecificInfosDto {
  Balcia: Balcia;
  BTA: BTA;
  Compensa: Compensa;
  Ergo: Ergo;
  Gjensidige: Gjensidige;
  IF: IF;
  LietuvosDraudimas: LietuvosDraudimas;
}

export interface LietuvosDraudimas extends BaseForInsurerSpecificInfoDto {
  AdministrativeUnit: number | null;
  DependLocality: number | null;
  DependStreet: number | null;
  DependStreetName: string | null;
  StreetNo: string;
  FloorExt: string;
  SpecialUsage: boolean | null;
}

export interface MtplRateBaseDto {
  OfferId: string | null;
  OfferNumber: string | null;

  RoadAssistancePremium: number | null;
  DriverAndPassengerInsurancePremium: number | null;
  Premium: number | null;
  TotalPremium: number | null;

  ErrorMessage: string | null;
  ExecutionTimeInSec: number | null;
}

export interface MtplRateDto extends MtplRateBaseDto {
  InsurerName: string;
}

export interface VehicleInfoDto {
  VehicleLicensePlate: string;
  VehicleVin: string;
  VehiclePowerKw: number | null;
  VehicleCubicCapacity: number | null;
  VehicleMaximumGrossWeight: number | null;
  VehicleSeats: number | null;
  VehicleWeight: number | null;
  VehicleManufacturedOn: string | null;
  VehicleFirstRegistrationOn: string | null;
  VehicleBrand: string;
  VehicleModel: string;
  VehicleClass: string;
  VehicleClassB: string;
  VehicleType: string;
  OwnerId: string;
  OwnerFirstName: string;
  OwnerLastName: string;
  OwnerBirthDate: string | null;
  OwnerCountryCode: string;
  OwnerAddress: string;
  OwnerDrivingLicenseDate: string | null;
  IF_ObjCityFromRegitra: string;
  IF_ObjCity: string;
  IF_MlYValue: string;
  IF_MlYType: string;
  IF_mdat: string;
  IF_riskGroup: string;
  IF_tpr_mdat: string;
  IF_arsav_int: string;
  IF_salt_int: string;
  IF_dsutikod_int: string;
  IF_drsk: string;
  IF_drsk12: string;
  IF_drsk2: string;
  IF_drsk212: string;
  IF_ssk: string;
  IF_ssk12: string;
  IF_ssk2: string;
  IF_ssk212: string;
  IF_tps: string;
  IF_tps12: string;
  IF_avsklt12: string;
  IF_avsklt: string;
  IF_avskuzs12: string;
  IF_avskuzs: string;
  IF_blogdrsk: string;
  IF_blogdrsk12: string;
  VehicleInfoRetrievedByInsurerName: string;
}

export interface OffersAzureResponse {
  "@odata.context": string;
  "@odata.count": number;
  value: OfferListEntryDto[];
}

export interface OfferAzureSearch {
  "@search.score": number;
  IsArchived: boolean | null;
  IsOwnerLegalPerson: boolean | null;
  LastModifiedAt: string | null;
  LastModifiedBy: string;
  LastModifiedByUsername: string;
  LastModifiedByUserFullName: string;
  OfferId: string;
  OfferRequestedAt: string | null;
  OfferRequestedBy: string;
  OfferRequestedByUsername: string;
  OfferRequestedByUserFullName: string;
  OtherDrivers: boolean | null;
  OtherDriverAge: number | null;
  OtherDriverExperience: number | null;
  OwnerAddress: string;
  OwnerBirthDate: string | null;
  OwnerCity: number | null;
  OwnerDrivingLicenseDate: string | null;
  OwnerFirstName: string;
  OwnerLastName: string;
  OwnerId: string;
  PolicyStartDate: string | null;
  PolicyStatusMessage: string | null;
  PolicyDocumentsStatusMessage: string | null;
  PolicyPeriod: number | null;
  PaymentCount: number | null;
  Status: number;
  StatusDescription: string;
  VehicleBrand: string;
  VehicleModel: string;
  VehicleClass: string;
  VehicleCubicCapacity: number | null;
  VehicleFirstRegistrationOn: string | null;
  VehicleLicensePlate: string;
  VehicleManufacturedOn: string | null;
  VehicleMaximumGrossWeight: number | null;
  VehiclePowerKw: number | null;
  VehicleSeats: number | null;
  VehicleWeight: number | null;
  VehicleUsage: number | null;
  VehicleVin: string;
  SelectedInsurer: string | null;
  OfferedInsurers: string[];
}

// Taxonomies and Settings
export type Taxonomy = {
  code: string;
  id: number;
};

export interface TaxonomyResponse {
  SAGCityOrDistrict: Taxonomy[];
  SAGCompensaMiniCASCO: Taxonomy[];
  SAGErgoCompanyType: Taxonomy[];
  SAGPolicyPeriod: Taxonomy[];
  SAGStatus: Taxonomy[];
  SAGVehicleClass: Taxonomy[];
  SAGVehicleUsageType: Taxonomy[];
  SAGLDAdministrativeUnit: Taxonomy[];
}

export interface TaxonomyUADResponse {
  ApplicationCode: Taxonomy[];
  ApplicationSetting: Taxonomy[];
  Country: Taxonomy[];
  CostCenter: Taxonomy[];
  Gender: Taxonomy[];
  SupportedLanguage: Taxonomy[];
  LanguageListType: Taxonomy[];
}

export interface Setting {
  userId: number;
  appSettingCodeId: number;
  userAppSettingValue: string;
  userAppSettingId: number;
  userAppSettingName: string;
  userAppSettingDescription: string;
  applicationCodeId: number;
  isDefault: boolean;
}

export type SettingsResponse = Setting[];
export type UserRole = "admin" | "internal" | "external";

export interface InsurerListItem
  extends BaseForInsurerSpecificInfoDto,
    MtplRateBaseDto {}

export interface InsurerListItems {
  Balcia: InsurerListItem;
  BTA: InsurerListItem;
  Compensa: InsurerListItem;
  Ergo: InsurerListItem;
  Gjensidige: InsurerListItem;
  IF: InsurerListItem;
  LietuvosDraudimas: InsurerListItem;
}

export interface BackendError {
  statusCode: number;
  errorCode: string;
  type: string;
  correlationID: string;
  messageCode: string;
  messageVariables: any[];
  statusDescription: string;
  message: string;
  formatedMessage: string;
  exceptionMessage: string;
  stackTrace: string;
}

export type LoadStatus = "none" | "loading" | "success" | "error";

export type TaxonomyState = TaxonomyTaxonomyState & {
  loadTaxonomyStatus: LoadStatus;
  loadTaxonomyUADStatus: LoadStatus;
  response: TaxonomyResponse;
};
export interface FormInitialState {
  VehiclePowerKw: number | null;
  VehicleCubicCapacity: number | null;
  VehicleMaximumGrossWeight: number | null;
  VehicleSeats: number | null;
  VehicleWeight: number | null;
  VehicleManufacturedOn: string | null;
  VehicleFirstRegistrationOn: string | null;
  VehicleBrand: string | null;
  VehicleModel: string | null;
  VehicleClass: number | null;
  OwnerFirstName: string;
  OwnerLastName: string;
  OwnerBirthDate: string | null;
  OwnerAddress: string | null;
  VehicleUsage: number | null;
  OwnerDrivingLicenseDate: string | null;
  OwnerCity: number | null;
  OwnerEmail: string | null;
  OwnerTelephone: string | null;
  OtherDrivers: boolean;
  OtherDriverAge: number | null;
  OtherDriverExperience: number | null;
  PolicyStartDate: string | null;
  PolicyPeriod: number | null;
  PaymentCount: number | null;
  Compensa_PolicyCoverageEURAndGreenCardCountries: boolean;
  Compensa_MiniCASCO: number | null;
  Ergo_DiscountPercent: number | null;
  Ergo_CompanyType: number | null;
  Gjensidige_ApplyMaxDiscount: boolean;
  Gjensidige_DiscountPercent: number | null;
  Gjensidige_SpecialUsage: boolean;
  LietuvosDraudimas_SpecialUsage: boolean;
}

// Updated formInitialState with default values
export const formInitialState: FormInitialState = {
  VehiclePowerKw: null,
  VehicleCubicCapacity: null,
  VehicleMaximumGrossWeight: null,
  VehicleSeats: null,
  VehicleWeight: null,
  VehicleManufacturedOn: null,
  VehicleFirstRegistrationOn: null,
  VehicleBrand: null,
  VehicleModel: null,
  VehicleClass: null,
  OwnerFirstName: "",
  OwnerLastName: "",
  OwnerBirthDate: null,
  OwnerAddress: null,
  VehicleUsage: null,
  OwnerDrivingLicenseDate: null,
  OwnerCity: null,
  OwnerEmail: null,
  OwnerTelephone: null,
  OtherDrivers: false,
  OtherDriverAge: null,
  OtherDriverExperience: null,
  PolicyStartDate: null,
  PolicyPeriod: null,
  PaymentCount: null,
  Compensa_PolicyCoverageEURAndGreenCardCountries: false,
  Compensa_MiniCASCO: null,
  Ergo_DiscountPercent: null,
  Ergo_CompanyType: null,
  Gjensidige_ApplyMaxDiscount: false,
  Gjensidige_DiscountPercent: null,
  Gjensidige_SpecialUsage: false,
  LietuvosDraudimas_SpecialUsage: false,
};

export type ByIdStateByTaxonomy = { [id: number]: Taxonomy };
export type AllIdsStateByTaxonomy = Taxonomy["id"][];
export type ByCodeStateByTaxonomy = { [code: string]: Taxonomy };

export type TaxonomyTaxonomyState = {
  SAGCompensaMiniCASCO: TaxonomyGroupState;
  SAGCityOrDistrict: TaxonomyGroupState;
  SAGLDAdministrativeUnit: TaxonomyGroupState;
  SAGErgoCompanyType: TaxonomyGroupState;
  SAGPolicyPeriod: TaxonomyGroupState;
  SAGStatus: TaxonomyGroupState;
  SAGVehicleClass: TaxonomyGroupState;
  SAGVehicleUsageType: TaxonomyGroupState;
  ApplicationCode: TaxonomyGroupState;
  ApplicationSetting: TaxonomyGroupState;
};

type TaxonomyGroupState = {
  byId: ByIdStateByTaxonomy;
  allIds: AllIdsStateByTaxonomy;
  byCode: ByCodeStateByTaxonomy;
  items: Taxonomy[];
};

export declare type DetailsListSortProp = {
  key: string;
  dir: string;
};
